import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isSpb: TComputedPropMapper<boolean> = props => {
  const geo = props.offer.geo?.address || [];
  const isSpb = geo.some(a => a.id === 2 || a.id === 4588);

  return isSpb;
};
